module.exports = __webpack_public_path__ + "static/media/social-icon-x-orange.22422cb7.svg";